import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils'
import moment from 'moment'
import { Button, Card, Select } from 'antd'

import Request from '../../request'
import 'react-bootstrap-typeahead/css/Typeahead.css'

import userRights from '../../components/_utils/userRights'

import { connect } from 'react-redux'

const Option = Select.Option


class ActivityReport extends Component {


    apiRequest = params => {

        return new Promise(async resolve => {

            if (this.state.studentId) {
                params.studentId = this.state.studentId
            }

            this.setState({ exportParams: params })

            let data = await Request.getallActivityReport({
                ...params

            })

            this.setState({ total: data.total })
            resolve(data)
        })
    }
    exportExcel = async () => {
        const { exportParams } = this.state


        this.setState({ loading: true })
        let x = await Request.exportActivityDataToExcel({
            ...exportParams
        })
        this.setState({ loading: false })

        if (!x.error) {
            window.open(x.url)
        }


    }
    reload = () => {
        this.table.current.reload()
    }

    constructor(props) {
        super(props)

        this.table = React.createRef()
        this.state = {
            total: 0,
            loading: false,
            studentId: '',
            searchLoading: false
        }
    }

    async componentDidMount() {


    }

    render() {

        const { studentData } = this.state

        const columns = [
            {
                title: 'Id',
                key: 'id',
                render: (val, record) => {
                    return (
                        <div>{record && record.studentId ? record.studentId.id : ''}</div>
                    )
                }
            },
            {
                title: 'Name',
                key: 'name',
                render: (val, record) => {
                    return (
                        <div>{record && record.studentId ? record.studentId.studentName : ''}</div>
                    )
                }
            },
            {
                title: 'Message',
                key: 'message',
                searchTextName: 'message',
                dataIndex: 'message',
                filterRegex: true
            },
            {
                title: 'User Name',
                key: 'username',
                searchTextName: 'username',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <div>{record && record.createdByUser ? record.createdByUser.name : ''}</div>
                    )
                }
            },
            {
                title: 'Time',
                key: 'createdByUser.time',
                searchDateName: 'createdByUser.time',
                filterRegex: true,
                render: (val, record) => {
                    return (
                        <div>{record && record.createdByUser ? moment(record.createdByUser.time).format('DD-MM-YYYY HH:mm:ss a') : ''}</div>
                    )
                }
            }
        ]

        return (
            <PageHeaderWrapper title={`
          Total Activities : ${this.state.total}`}>
                <Card style={{ marginBottom: 10 }}>
                    {
                        userRights.checkRights("ActivityReportExcelExport.view") ?
                            <Button type={'default'}
                                loading={this.state.loading}
                                onClick={() => {
                                    this.exportExcel()
                                }}>Export Excel</Button>
                            : null
                    }
                </Card>

                <Card bordered={true}>
                    <h5 style={{ paddingLeft: '8px' }}>
                        SEARCH BY STUDENT
                    </h5>

                    <Select
                        showSearch
                        allowClear
                        style={{
                            width: 300,
                            paddingLeft: '8px',
                            marginBottom: '10px'
                        }}
                        value={this.state.studentId}
                        placeholder="Search student by name and id"
                        filterOption={false}
                        onSearch={async (test) => {
                            this.setState({
                                searchLoading: true
                            })

                            let { data } = await Request.studentList(test)
                            this.setState({ studentData: data, searchLoading: false })
                        }}
                        onChange={studentId => {
                            this.setState({ studentId }, () => {
                                this.table.current.reload()
                            })
                        }}
                    >
                        {studentData &&
                            studentData.map((val, idn) => {
                                return (
                                    <Option key={idn} value={val._id}>
                                        {`${val.studentName} (id:${val.id})`}
                                    </Option>
                                )
                            })}
                    </Select>

                    <TableComp
                        columns={columns}
                        rowKey={(item, x) => {
                            return x
                        }}
                        id={'activityReport'}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ActivityReport)
